import type { AxiosRequestConfig, Method } from "axios";

import { api } from "@/server/axios";

type UseFetchOptions = {
  method: Method;
  url: string;
  params?: Record<string, unknown>;
  body?: Record<string, unknown> | FormData;
};

export async function useFetch<T>({ method, url, params, body }: UseFetchOptions): Promise<T> {
  const config: AxiosRequestConfig = {
    method,
    url,
    params,
    data: body,
  };

  const response = await api.request<T>(config as AxiosRequestConfig);
  return response.data;
}
